var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "gift_card_assign_task",
      attrs: { type: "card" },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: { click: _vm.handleToGiftCardAssignTaskTable },
            },
            [_vm._v("\n      返回礼品卡发放列表\n    ")]
          ),
          _vm._v(" "),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              attrs: { placeholder: "请选择选项用户分组" },
              model: {
                value: _vm.memberLabel,
                callback: function ($$v) {
                  _vm.memberLabel = $$v
                },
                expression: "memberLabel",
              },
            },
            _vm._l(_vm.memberLabels, function (item) {
              return _c(
                "el-option",
                {
                  key: item.fnId,
                  attrs: { label: item.labelName, value: item.fnId },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", [_vm._v(_vm._s(item.labelName))]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(item.memberCount))]),
                    ]
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入内容", clearable: "" },
            model: {
              value: _vm.keywords,
              callback: function ($$v) {
                _vm.keywords = $$v
              },
              expression: "keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.queryMemberSearchCombo },
            },
            [_vm._v("\n      查询\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.formRules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-form-item",
            { staticClass: "member_check", attrs: { label: "选项用户：" } },
            [
              _c("el-transfer", {
                attrs: {
                  props: {
                    key: "userFnId",
                    label: "alias",
                  },
                  titles: ["可选用户", "已选用户"],
                  data: _vm.memberList,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var option = ref.option
                      return _c("span", {}, [
                        _vm._v(
                          _vm._s(option.userName) + " | " + _vm._s(option.alias)
                        ),
                      ])
                    },
                  },
                ]),
                model: {
                  value: _vm.form.userFnIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "userFnIds", $$v)
                  },
                  expression: "form.userFnIds",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "卡片名称：" } }, [
            _c("span", [
              _vm._v("\n        " + _vm._s(_vm.giftCard.title) + "\n        "),
              _vm.giftCard.subTitle
                ? _c(
                    "span",
                    [
                      _c("el-divider", { attrs: { direction: "vertical" } }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.giftCard.subTitle) +
                          "\n        "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "选择卡样：" } }, [
            _c("div", { staticStyle: { width: "200px" } }, [
              _c("div", { staticClass: "gift_card" }, [
                _c(
                  "div",
                  { staticClass: "cover-image" },
                  [
                    _vm.giftCard.coverImage1
                      ? _c("el-image", {
                          ref: "gift_card_cover_image_1",
                          staticClass: "gift-card-image",
                          class: {
                            "gift-card-image-selected":
                              _vm.form.coverImage == _vm.giftCard.coverImage1,
                          },
                          attrs: { src: _vm.giftCard.coverImage1 },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.selectCoverImage(
                                _vm.giftCard.coverImage1
                              )
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.giftCard.coverImage2
                      ? _c("el-image", {
                          ref: "gift_card_cover_image_2",
                          staticClass: "gift-card-image",
                          class: {
                            "gift-card-image-selected":
                              _vm.form.coverImage == _vm.giftCard.coverImage2,
                          },
                          attrs: { src: _vm.giftCard.coverImage2 },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.selectCoverImage(
                                _vm.giftCard.coverImage2
                              )
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.giftCard.coverImage3
                      ? _c("el-image", {
                          ref: "gift_card_cover_image_3",
                          staticClass: "gift-card-image",
                          class: {
                            "gift-card-image-selected":
                              _vm.form.coverImage == _vm.giftCard.coverImage3,
                          },
                          attrs: { src: _vm.giftCard.coverImage3 },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.selectCoverImage(
                                _vm.giftCard.coverImage3
                              )
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.giftCard.coverImage4
                      ? _c("el-image", {
                          ref: "gift_card_cover_image_4",
                          staticClass: "gift-card-image",
                          class: {
                            "gift-card-image-selected":
                              _vm.form.coverImage == _vm.giftCard.coverImage4,
                          },
                          attrs: { src: _vm.giftCard.coverImage4 },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.selectCoverImage(
                                _vm.giftCard.coverImage4
                              )
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "任务名称：" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  placeholder: "请输入任务名称",
                  clearable: "",
                  maxlength: "30",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.taskName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "taskName", $$v)
                  },
                  expression: "form.taskName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "卡片面值：" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { placeholder: "请选择卡片面值" },
                  model: {
                    value: _vm.form.cardValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "cardValue", $$v)
                    },
                    expression: "form.cardValue",
                  },
                },
                _vm._l(_vm.faceValues, function (item) {
                  return _c("el-option", {
                    key: item.faceValue,
                    attrs: {
                      label: item.faceValue + "元",
                      value: item.faceValue,
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v("（ 每张卡片面值 ）")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "发放数量：" } },
            [
              _c("el-input-number", {
                attrs: {
                  placeholder: "请输入发放数量",
                  min: 1,
                  max: 40,
                  precision: 0,
                  size: "small",
                },
                model: {
                  value: _vm.form.assignNum,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "assignNum", $$v)
                  },
                  expression: "form.assignNum",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("（ /人，最大40 ）")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "充值类型：" } },
            [
              _vm.giftCard.type === "member"
                ? [
                    _c("el-tag", { attrs: { type: "primary" } }, [
                      _vm._v("本金"),
                    ]),
                  ]
                : _c("el-switch", {
                    attrs: {
                      "active-text": "本金",
                      "inactive-text": "赠金",
                      "active-value": "principal",
                      "inactive-value": "bonus",
                    },
                    model: {
                      value: _vm.form.chargeType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chargeType", $$v)
                      },
                      expression: "form.chargeType",
                    },
                  }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.form.chargeType === "principal"
            ? _c(
                "el-form-item",
                { attrs: { label: "CRM流水号：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      placeholder: "请输入CRM流水号",
                      clearable: "",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.crmNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "crmNum", $$v)
                      },
                      expression: "form.crmNum",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("el-button", { on: { click: _vm.reset } }, [
                _vm._v("\n        重置\n      "),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("\n        提交\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }